import * as React from 'react';
import {FormattedMessage} from "react-intl";

import {
    useResidenceExplorerStore,
    selectExternalSunStudyUrl,
    selectHasSunStudy,
    selectShowSunStudy,
    selectViewHasSunStudy,
} from "features/residenceExplorer/store/useResidenceExplorerStore";
import {useDeviceStore, selectIsMobile} from 'features/ui/store/useDeviceStore';

import './_residenceExplorerFilters.scss'

import {Icon} from "@atoms/Media/Icon";
import {Button, ButtonColor, ButtonSize, ButtonType} from "@atoms/LinksAndButtons/Button";
import {
    ResidenceExplorerFilterButtons
} from "features/residenceExplorer/components/ResidenceExplorerV2/_residenceExplorerFilterButtons";


export const ResidenceExplorerFilters: React.FunctionComponent = () => {
    const hasSunStudy = useResidenceExplorerStore(selectHasSunStudy);
    const viewHasSunStudy = useResidenceExplorerStore(selectViewHasSunStudy);
    const externalSunStudyUrl = useResidenceExplorerStore(selectExternalSunStudyUrl);
    const showSunStudy = useResidenceExplorerStore(selectShowSunStudy);
    const setShowSunStudy = useResidenceExplorerStore(state => state.setShowSunStudy);
    const isMobile = useDeviceStore(selectIsMobile);

    const onSunStudyClick = () => {
        if(externalSunStudyUrl) {
            window.open(externalSunStudyUrl, '_blank', 'noopener,noreferrer');
            return;
        }

        setShowSunStudy(true);
    };

    return (
        <div className="residence-explorer-filters">
            {!isMobile && <div className="residence-explorer-filters__filters-buttons">
                <ResidenceExplorerFilterButtons />
            </div>}

            {(hasSunStudy && !showSunStudy && viewHasSunStudy || externalSunStudyUrl) &&
                <div className="residence-explorer-filters__sunstudy-button__wrapper">
                    <Button
                        icon={<Icon name="sun-outline"/>}
                        onClick={onSunStudyClick}
                        className="residence-explorer__sunstudy-button"
                        buttonColor={ButtonColor.DEFAULT} 
                        buttonSize={ButtonSize.DEFAULT} 
                        buttonType={ButtonType.DEFAULT} 
                    >
                        <FormattedMessage id="jm.components.ResidenceExplorer.viewSunStudy"/>
                    </Button>
                </div>
            }
        </div>
    );
};
